import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-core-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
  @Input()
  message: string = 'Loading';

  @Input()
  diameter: number = 96;
}
